<template>
  <aside
    class="overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs fixed-start"
    :class="[
      isRTL ? 'me-3 rotate-caret fixed-end' : '',
      { 'sidenav--collapsed': isSidenavCollapsed },
    ]"
    id="sidenav-main"
  >
    <!-- Brand + hamburger -->
    <div
      class="sidenav-header d-flex align-items-center px-0.25 padding-left: 0.5rem"
      :class="{ 'sidenav-header--collapsed': isSidenavCollapsed }"
      style="height:4.5rem;"
    >
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <div class="sidenav-header-main">
        <div
          class="m-0 navbar-brand d-flex align-items-center gap-2 sidenav-brand"
          :class="{ 'sidenav-brand--clickable': isSidenavCollapsed }"
          :title="isSidenavCollapsed ? 'Expand menu' : undefined"
          @click="onBrandClick"
        >
          <div
            class="d-flex align-items-center justify-content-center flex-shrink-0 sidenav-brand-icon"
            style="width:2.2rem;height:2.2rem;background:linear-gradient(135deg,#344767 0%,#627594 100%);border-radius:8px;"
          >
            <i class="fas fa-vial text-white" style="font-size:0.85rem;"></i>
          </div>
          <div
            class="sidenav-brand-text"
            :class="{ 'sidenav-brand-text--hidden': isSidenavCollapsed }"
          >
            <span class="font-weight-bold d-block" style="font-size:0.9rem;color:#344767;line-height:1.2;">TestOps Hub</span>
            <span style="font-size:0.65rem;color:#8392ab;letter-spacing:0.04em;">QA Platform</span>
          </div>
        </div>
        <button
          v-show="!isSidenavCollapsed"
          type="button"
          class="sidenav-hamburger"
          aria-label="Collapse menu"
          :aria-expanded="true"
          @click.stop="toggleCollapsed"
        >
          <span class="sidenav-toggler-inner" aria-hidden="true">
            <span class="sidenav-toggler-line"></span>
            <span class="sidenav-toggler-line"></span>
            <span class="sidenav-toggler-line"></span>
          </span>
        </button>
      </div>
    </div>

    <sidenav-list :cardBg="customClass" />
  </aside>
</template>

<script>
import SidenavList from "./SidenavList.vue";
import { mapMutations, mapState } from "vuex";

export default {
  name: "index",
  components: { SidenavList },
  props: {
    customClass: { type: String, default: "" },
  },
  computed: {
    ...mapState(["isRTL", "isSidenavCollapsed"]),
  },
  methods: {
    ...mapMutations(["toggleSidenavCollapsed"]),
    toggleCollapsed() {
      this.toggleSidenavCollapsed();
    },
    onBrandClick() {
      if (!this.isSidenavCollapsed) return;
      this.toggleCollapsed();
    },
  },
};
</script>

<style scoped>
.sidenav-header-main {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2.5rem;
  width: 100%;
  min-width: 0;
  position: relative;
}

.sidenav-header {
  position: relative;
  z-index: 2;
  background: #fff;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

.sidenav-hamburger {
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #67748e;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  text-decoration: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  appearance: none;
}

.sidenav-hamburger:hover,
.sidenav-hamburger:focus,
.sidenav-hamburger:active {
  color: #344767;
  background: transparent;
  box-shadow: none;
  outline: none;
}

.sidenav-toggler-inner {
  width: 18px;
}

.sidenav-toggler-line {
  display: block;
  width: 100%;
  height: 2px;
  background: currentColor;
  border-radius: 1px;
  transform: none !important;
}

.sidenav-toggler-line:not(:last-child) {
  margin-bottom: 3px;
}

.sidenav-header--collapsed {
  height: 4.5rem !important;
  overflow: hidden;
}

.sidenav-header--collapsed .sidenav-brand {
  flex: 0 0 auto;
  padding: 0.5rem 0.5rem 0.5rem 1rem !important;
}

.sidenav-brand--clickable .sidenav-brand-icon {
  cursor: pointer;
}

.sidenav-brand {
  position: relative;
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  padding: 0.5rem 0.5rem 0.5rem 1rem !important;
  text-decoration: none;
  background: transparent !important;
  box-shadow: none !important;
}

.sidenav-brand--clickable {
  cursor: pointer;
}

.sidenav-brand:hover,
.sidenav-brand:focus,
.sidenav-brand:active {
  background: transparent !important;
  box-shadow: none !important;
  outline: none;
  opacity: 1;
}

.sidenav-brand-text {
  white-space: nowrap;
  overflow: hidden;
}

.sidenav-brand-text--hidden {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  visibility: hidden;
  overflow: hidden;
  pointer-events: none;
  transition: none !important;
}
</style>

<style>
#sidenav-main.sidenav--collapsed {
  width: 6rem !important;
  max-width: 6rem !important;
  overflow-x: hidden !important;
  transition: none !important;
}

#sidenav-main.sidenav--collapsed:hover {
  width: 6rem !important;
  max-width: 6rem !important;
}

#sidenav-main.sidenav--collapsed.fixed-start ~ .main-content {
  margin-left: 6rem !important;
  transition: none !important;
}

#sidenav-main.sidenav--collapsed .sidenav-section-label {
  display: none !important;
  transition: none !important;
}

#sidenav-main.sidenav--collapsed .nav-link-text {
  display: none !important;
  opacity: 0 !important;
  transition: none !important;
}

#sidenav-main.sidenav--collapsed .sidenav-caret,
#sidenav-main.sidenav--collapsed .sidenav-children {
  display: none !important;
}

#sidenav-main.sidenav--collapsed .navbar-nav > .nav-item .nav-link > .d-flex,
#sidenav-main.sidenav--collapsed .navbar-nav > .nav-item .nav-link > div.d-flex {
  justify-content: center;
}

#sidenav-main.sidenav--collapsed .sidenav-icon {
  margin-right: 0 !important;
}

#sidenav-main.sidenav--collapsed .navbar-nav > .nav-item .nav-link {
  justify-content: center;
  width: calc(100% - 1rem) !important;
  margin-left: 0.5rem !important;
  margin-right: 0.5rem !important;
  padding-left: 0.85rem !important;
  padding-right: 0.85rem !important;
}

#sidenav-main.sidenav--collapsed .navbar-nav > .nav-item .nav-link.active {
  border-left: none !important;
  border-radius: 0.5rem !important;
  padding-left: 0.85rem !important;
}

#sidenav-main.sidenav--collapsed .sidenav-header {
  border-bottom: 1px solid #e9ecef;
}
</style>
